import { render } from "./PrayerTimes.vue?vue&type=template&id=550bc837&scoped=true"
import script from "./PrayerTimes.vue?vue&type=script&lang=js"
export * from "./PrayerTimes.vue?vue&type=script&lang=js"

import "./PrayerTimes.vue?vue&type=style&index=0&id=550bc837&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-550bc837"]])

export default __exports__